import { useEffect, useState } from "react";

import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";

import User from "data/firestore/user";
import ExpandableCard from "components/ExpandableCard";

// Loads a user's snapshot-derived chart data and renders it in a card, with
// loading / empty states. (Formerly "GatekeepChart" -- the paid-feature gate it
// implied was never wired up: hasAccessToPaidFeatures was hardcoded true, so the
// "see demo data" branch was dead. Charts are not gatekept, so it's just a card.)
const ChartCard = ({
  uid,
  title,
  subtitle,
  children,
  dataLoader,
  isEmptyChecker,
  height = 400,
  openedByDefault = true,
  contentSX = { padding: 1 },
  headerAction,
}) => {
  const [data, setData] = useState(null);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const user = new User(uid);
    user.load(true).then(async () => {
      const result = await dataLoader(user);
      setData(result);
      if (isEmptyChecker) {
        setIsEmpty(isEmptyChecker(result));
      }
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  const renderContent = () => {
    if (isLoading) {
      return <Typography variant="overline">Loading...</Typography>;
    }
    if (!data || isEmpty) {
      return (
        <Typography variant="overline">
          No completed tug sessions yet
        </Typography>
      );
    }
    return (
      <Grid container flexDirection="column" style={{ height }}>
        {children(data)}
      </Grid>
    );
  };

  // Use a plain Card with custom header action when headerAction is provided
  if (headerAction) {
    return (
      <Card
        style={{
          border: "0.5px solid",
          borderColor: "lightgrey",
          margin: "10px 0px",
          fontFamily: "Inter",
          fontWeight: 300,
        }}
      >
        <CardHeader
          title={title}
          subheader={subtitle}
          action={headerAction}
          style={{ padding: 16 }}
        />
        <CardContent
          style={{ display: "flex", flexFlow: "column", padding: 8 }}
        >
          {renderContent()}
        </CardContent>
      </Card>
    );
  }

  return (
    <ExpandableCard
      title={title}
      subtitle={subtitle}
      contentSX={contentSX}
      openedByDefault={openedByDefault}
    >
      {renderContent()}
    </ExpandableCard>
  );
};

export default ChartCard;
